const COOKIE_NAME = 'sloty_cookie_consent';

export interface ConsentPreferences {
  necessary: boolean;
  functional: boolean;
  analytics: boolean;
}

function getCookieValue(name: string): string | undefined {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : undefined;
}

export function getConsentPreferences(): ConsentPreferences | null {
  const value = getCookieValue(COOKIE_NAME);
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    return value === 'true'
      ? { necessary: true, functional: true, analytics: true }
      : null;
  }
}

export function hasConsentFor(category: keyof ConsentPreferences): boolean {
  const prefs = getConsentPreferences();
  if (!prefs) return category === 'necessary';
  return prefs[category];
}
